import React from 'react';
import { FaTemperatureHigh, FaTint, FaSmog, FaFlask } from 'react-icons/fa';
import StatusBadge from './StatusBadge';
import { statusMeta, formatValue } from '../monitoringUtils';

const ICONS = {
  temperature: FaTemperatureHigh,
  humidity: FaTint,
  co2: FaSmog,
  ammonia: FaFlask,
};

// Live sensor card for a single metric, with current value, status and the
// age-appropriate optimal range.
export default function SensorCard({ metric, value, status, decimals = 1, unit, optimalRange }) {
  const Icon = ICONS[metric] || FaTemperatureHigh;
  const meta = statusMeta(status);

  return (
    <div className={`rounded-xl border ${meta.border} ${meta.bg} p-4 flex flex-col gap-3 shadow-sm`}>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2 text-gray-600">
          <Icon className={`text-lg ${meta.text}`} />
          <span className="text-sm font-medium">{label(metric)}</span>
        </div>
        <StatusBadge status={status} />
      </div>
      <div className="flex items-end gap-1">
        <span className="text-3xl font-bold text-gray-800">{formatValue(value, decimals)}</span>
        <span className="text-sm text-gray-500 mb-1">{unit}</span>
      </div>
      {optimalRange && (
        <div className="text-xs text-gray-500">
          Optimal: {optimalRange[0]}–{optimalRange[1]} {unit}
        </div>
      )}
    </div>
  );
}

function label(metric) {
  return {
    temperature: 'Temperature',
    humidity: 'Humidity',
    co2: 'CO₂',
    ammonia: 'Ammonia',
  }[metric] || metric;
}
